<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    role="presentation"
    class="svg"
  >
    <g :fill="iconColor" :fill-opacity="opacity">
      <path v-for="icon in icons[iconName]" :key="icon" :d="icon" />
    </g>
  </svg>
</template>

<script>
import { icons } from '@/utils/icons.js';
export default {
  props: {
    iconName: {
      type: String,
      default: 'box',
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
    iconColor: {
      type: String,
      default: 'currentColor',
    },
    opacity: {
      type: Number,
      default: 1,
    },
  },
  setup() {
    return {
      icons,
    };
  },
};
</script>

<style scoped>
.svg {
  display: inline-block;
  vertical-align: baseline;
}
</style>
